/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fair_Warm_Finch_PlanInputs */

const en_fair_warm_finch_plan = /** @type {(inputs: Fair_Warm_Finch_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Managers`)
};

const de_fair_warm_finch_plan = /** @type {(inputs: Fair_Warm_Finch_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manager`)
};

/**
* | output |
* | --- |
* | "Managers" |
*
* @param {Fair_Warm_Finch_PlanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fair_warm_finch_plan = /** @type {((inputs?: Fair_Warm_Finch_PlanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fair_Warm_Finch_PlanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fair_warm_finch_plan(inputs)
	return de_fair_warm_finch_plan(inputs)
});